/* eslint-disable @typescript-eslint/no-explicit-any */

// MicroMconfig is defined in local.js, used in index.HTML. this allows to be changed after compiled

const origin = window.location.origin;
const isLocalhost = origin.startsWith('http://localhost') || origin.startsWith('https://localhost');

const config = isLocalhost ? (window as any).MicroMconfig.localhost : (window as any).MicroMconfig.production;

export const API_URL = `${config.ORIGIN}${config.API_PREFIX}`;
export const APP_ID = config.APP_ID;
export const GOOGLE_MAPS_API_KEY = config.GOOGLE_MAPS_API_KEY;